import React from "react";

const CountryConfigContext = React.createContext();

export default CountryConfigContext;
